import { llmThreadLiteSchema } from "@redotech/redo-model/agents/llm-thread-lite";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getThreadsByVersionedAgent = {
  name: "getThreadsByVersionedAgent" as const,
  input: z.object({
    versionedAgentId: zExt.objectId(),
    page: z.number(),
    pageSize: z.number(),
  }),
  output: z.object({
    data: z.array(llmThreadLiteSchema),
    totalCount: z.number(),
  }),
};
